module.exports = "../fonts/Vector 13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Vector 13.svg
// module id = 284
// module chunks = 0